import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../constants";
import {
  GetTournamentEntryListParams,
  handleGetMyTournamentEntries,
} from "../../api-clients/tournamentsClient";

interface MyTournamentEntryListParams extends GetTournamentEntryListParams {
  enabled?: boolean;
  retry?: number | boolean;
}

function useGetMyTournamentEntryListQuery({
  enabled,
  retry,
  ...entryListParams
}: MyTournamentEntryListParams) {
  const query = useQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.ENTRY_LIST, entryListParams.tournamentId],
    queryFn: () => handleGetMyTournamentEntries({ ...entryListParams }),
    enabled,
    retry,
  });
  return query;
}

export default useGetMyTournamentEntryListQuery;
